const tabs = {
  halloween: [1116]
};

export function getTab(slotName: number) {
  const trueTab = Object.keys(tabs).reduce(
    (acc, tab) => (tabs[tab as keyof typeof tabs].findIndex(item => item === slotName) === -1 ? acc : [...acc, tab]),
    ['slotMachines'],
  );
  return trueTab;
}

